import React, { Component, Fragment } from "react";
import _ from "lodash";
import "./style.css";
import ReportTitleSection from "../../../../libraries/ReportGenerator/ReportTitleSection";
import { onrInServiceRailFailureReportinstrucions } from "./instructionsList";
import ReportTableSectionRenderer from "../../../../libraries/ReportGenerator";
import { Col, Row } from "reactstrap";

export const ONR_InServiceRailFailureReportInstructions = () => {
  return (
    <React.Fragment>
      <div className="avoid-break-in-printing onr_cwr-maintenance-record-form">
        <ReportTitleSection title="IDENTIFICATION OF RAIL" hideLogo={true} fontSizeOverride="26px" />
        <span className="half-spacer"></span>
        <ol style={{ fontSize: "22px" }}>
          <li>
            <div>
              <div>{onrInServiceRailFailureReportinstrucions["1a"].span}</div>
              <span className="half-spacer"></span>
              {onrInServiceRailFailureReportinstrucions["1a"].letters.map((letter) => {
                if (!letter) {
                  return (
                    <Fragment>
                      <div style={{ borderBottom: "1px solid" }}></div>
                      <span className="half-spacer"></span>
                    </Fragment>
                  );
                } else {
                  return (
                    <div style={{ display: "flex", paddingBottom: "10px" }}>
                      <div style={{ minWidth: "150px", width: "150px", fontWeight: 600 }}>{letter.abrev}</div>
                      <div>{`${letter.desctiption}`}</div>
                    </div>
                  );
                }
              })}
              <div>{onrInServiceRailFailureReportinstrucions["1b"].span}</div>
              <span className="half-spacer"></span>

              <Row>
                <Col md={1}></Col>
                <Col md={10}>
                  <table className="table-bordered" style={{ width: "100%" }}>
                    <ReportTableSectionRenderer
                      rowsData={onrInServiceRailFailureReportinstrucions["1b"].table.data}
                      section={onrInServiceRailFailureReportinstrucions["1b"].table.schema}
                    />
                  </table>
                </Col>
                <Col md={1}></Col>
              </Row>
            </div>
          </li>
          <li>
            <div>{onrInServiceRailFailureReportinstrucions[2].span1}</div>
            <span className="half-spacer"></span>
            <div>{onrInServiceRailFailureReportinstrucions[2].span2}</div>
            <span className="half-spacer"></span>
            <div>{onrInServiceRailFailureReportinstrucions[2].span3}</div>
            <span className="half-spacer"></span>
          </li>
        </ol>
      </div>
    </React.Fragment>
  );
};
export default ONR_InServiceRailFailureReportInstructions;



// WEBPACK FOOTER //
// ./src/components/Reports/ONR/InServiceRailFailureReport/instructions.jsx